import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=3a209772&scoped=true"
import script from "./AppLogo.vue?vue&type=script&lang=ts"
export * from "./AppLogo.vue?vue&type=script&lang=ts"
import style0 from "./AppLogo.vue?vue&type=style&index=0&id=3a209772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a209772",
  null
  
)

export default component.exports